/** 普通网格查询策略参数，空间索引与自适应查询共享同一小集合边界。 */
export const SceneMeshRaycastPolicy = {
  /** 小于此候选数直接使用原生精确求交。 */
  minimumCandidates: 64,
  /** 每条路径每轮采集四个完整样本，保留中间两个的均值，避免单次尖峰主导选择。 */
  samplesPerPath: 4,
  /** 决策后保持的查询次数；随后重新采样以适应场景变化。 */
  reassessInterval: 128,
  /** 抑制测量噪声引发反复切换的相对迟滞范围。 */
  hysteresisRatio: 0.02,
} as const;
